import React, { Suspense, lazy, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Seeker_Register from "../V1/Modules/D5art/RMS/Components/Auth/Seeker_Register";
import Sample from "../Sample";
import CurrencyProvider from "../Context/CurrencyContext";
import Assessment from "../V1/Modules/D5art/Landing/JordanEvent/Pages/Assessment";
import DnaProtectedRoute from "./DnaProtectedRoute";
import Profile from "../V1/Modules/D5art/Admin/Components/Auth/Profile";
import AdminProtectedRoute from "./AdminProtectedRoute";
import RedisCitySelector from "../V1/Modules/D5art/Testing/Pages/RedisCitySelector";
import CareerGpt from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/CareerGpt";
// import CareerGPTChat from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/CareerGPTChat";
// import CareerGptReport from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/CareerGptReport";
import PromptPage from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/Component/PromptPage";
import SkillsPage from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/Component/SkillsPage";
import CareerRoadmap from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/Component/CareerRoadmap/CareerRoadmap";
import RoadmapPage from "../V1/Modules/D5art/LMS/Components/Pages/CareerGpt/Component/RoadmapPage";




// AIDM
const Dashboard = lazy(() => import("../V1/Modules/AIDM/Dashboard/Pages/Dashboard"));
const AIDMCourses = lazy(() => import("../V1/Modules/AIDM/Pages/Courses/Landing"));
const Description = lazy(() => import("../V1/Modules/AIDM/Pages/Description/Description"));
const Mycourses = lazy(() => import("../V1/Modules/AIDM/Dashboard/Pages/Mycourses/Mycourses"));
const CourseModules = lazy(() => import("../V1/Modules/AIDM/Dashboard/Pages/Mycourses/Mycourses"));
const Myassessment = lazy(() => import("../V1/Modules/AIDM/Dashboard/Pages/Myassessment"));///ADMIN
const NotFound = lazy(() => import("../V1/Modules/D5art/Landing/NotFound/NotFound"));
const Terms_Condition = lazy(() => import("../V1/Modules/D5art/Landing/T&C/Terms_Condition"));
const Privacy_Policy = lazy(() => import("../V1/Modules/D5art/Landing/T&C/Privacy_Policy"));
const Refund_Policy = lazy(() => import("../V1/Modules/D5art/Landing/T&C/Refund_Policy"));
/*Auth*/
const SeekerLogin = lazy(() => import("../V1/Modules/D5art/Auth/Login/SeekerLogin"));
const RecruiterLogin = lazy(() => import("../V1/Modules/D5art/Auth/Login/RecruiterLogin"));
const ValidatorLogin = lazy(() => import("../V1/Modules/D5art/Auth/Login/ValidatorLogin"));
const ResetPasswordPage = lazy(() => import("../V1/Modules/D5art/Auth/Login/ResetPasswordPage"));
/*Registraiton*/
const SeekerRegister = lazy(() => import("../V1/Modules/D5art/Auth/Register/SeekerRegister"));
const RecruiterRegister = lazy(() => import("../V1/Modules/D5art/Auth/Register/RecruiterRegister"));
const ValidatorRegister = lazy(() => import("../V1/Modules/D5art/Auth/Register/ValidatorRegister"));

/*Seeker Pages*/
const Home = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Home/Home"));
const NewHome = lazy(() => import("../V1/Modules/D5art/NewLanding/Landing/Landing"));
const Ouroffering = lazy(() => import("../V1/Modules/D5art/NewLanding/Landing/Ouroffering"));
const HREvent = lazy(() => import("../V1/Modules/D5art/Landing/HrEvent/HREvent"));
const ValidationResult = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/Validation/ValidationResult/ValidationResult"));




const SkillArenalist = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/Seeker_SkillArenalist/SkillArenalist"));
const Skillmarket = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/seeker_Skillmarket/Skillmarket"));
const SeekerUserDashboard = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Dashboard/UserDashboard"));
const Profileupdate = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/Profileupdate/Profileupdate"));
const FullProfile = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/FullProfile/FullProfile"));
const Congrats = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/Profileupdate/Congrats"));
const AssessmentResult = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/AssessmentResult"));
const UpSkill = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/UpSkill"));

/*Seeker Job Posting*/

/*Recruiter Pages*/
const RecruiterHome = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_Home/Recruiter_Home"));
const RecruiterSkillArenalist = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_SkillArenalist/SkillArenalist"));
const RecruiterSkillmarket = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_Skillmarket/Skillmarket"));
const RecruiterUserDashboard = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_UserDashboard/Dashboard/UserDashboard"));
const RecruiterGPT = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_GPT/RecruiterGPT"));
const GPTSearchResults = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_GPT/GPTSearchResults"));

// 
/*Recruiter Job Posting*/
const JobOpeningRegistration = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_JobPosting/JobOpeningRegistration"));
const JobArena = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_JobPosting/JobArena"));
const JobDetails = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Recruiter/Recruiter_JobPosting/JobDetails"));


/*Validator Pages*/

/*Courses*/
const Courses = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/ExploreCourses/Courses"));
const CoursePreview = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/CoursePreview/CoursePreview"));
const CourseVideo = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/CourseVideo/CourseVideo"));
const PreAssessment = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/Assessment/PreAssessment"));
const NftCertificate = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/NftCertificate"));
// const Myjobs = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Postajob/Myjobs"));
// const Jobdetail = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Postajob/Jobdetail"));
// const Myjobs = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Postajob/Myjobs"));
// const Jobdetail = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Postajob/Jobdetail"));


// DNA
const DnaResult = lazy(() => import("../V1/Modules/D5art/Landing/DNA/DnaResult/DnaResult"));
const DnaConsultations = lazy(() => import("../V1/Modules/D5art/Landing/DNA/DnaResult/DnaConsultations"));
const AboutMe = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/AboutMe/AboutMe"));

//COE
const CeoHome = lazy(() => import('../V1/Modules/COE/Pages/Home'));
const CeoDetails = lazy(() => import('../V1/Modules/COE/Pages/Coe'));
const CeoCareerHub = lazy(() => import('../V1/Modules/COE/Pages/CareerHub'));
const CeoMyDashboard = lazy(() => import('../V1/Modules/COE/Pages/MyDashboard'));
const CeoDnaAi = lazy(() => import('../V1/Modules/COE/Pages/DnaAi'));



/*Cxo*/
const CXOLogin = lazy(() => import("../V1/Modules/CXO/Login/Login"));
const CXOHome = lazy(() => import("../V1/Modules/CXO/Pages/Landing/Home"));
const CXODashboard = lazy(() => import("../V1/Modules/CXO/Pages/Dashboard/Dashboard"));
const CXOCareerhub = lazy(() => import("../V1/Modules/CXO/Pages/Careerhub/Careerhub"));
const Ticket = lazy(() => import("../V1/Modules/CXO/Pages/Ticket"));
const CXODna = lazy(() => import("../V1/Modules/CXO/Pages/DNA/Dna"));
const Userdata = lazy(() => import("../V1/Modules/CXO/Adminpanel/Pages/Userdata"));
const Group = lazy(() => import("../V1/Modules/CXO/Adminpanel/Pages/Group"));
const Consultation = lazy(() => import("../V1/Modules/CXO/Adminpanel/Pages/Consultation"));
const Revenue = lazy(() => import("../V1/Modules/CXO/Adminpanel/Pages/Revenue"));

/*Common*/
const Faq = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Faq/Faq"));
const Jordanhome = lazy(() => import("../V1/Modules/D5art/Landing/JordanEvent/Pages/Home"));
const Dnahome = lazy(() => import("../V1/Modules/D5art/Landing/DNA/DnaHome"));
const EventAssessment = lazy(() => import("../V1/Modules/D5art/Landing/JordanEvent/Pages/Assessment"));
const JordanResult = lazy(() => import("../V1/Modules/D5art/Landing/JordanEvent/Pages/AssessmentResult/Result"));
const PsychometricAssessment = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/Assessment/PsychometricAssessment"));
const PsychometricResult = lazy(() => import("../V1/Modules/D5art/LMS/Components/Pages/Assessment/PsychometricResult"));

/*Testing*/
const KeywordSearch = lazy(() => import("../V1/Modules/D5art/Testing/Pages/KeywordSearch"));
const RecruitGPT = lazy(() => import("../V1/Modules/D5art/Testing/Pages/RecruitGPT"));

// PaymentTesting
const TestPayment = lazy(() => import('../V1/Modules/D5art/LMS/Components/Pages/Payment/TestPayment'));
const StripeSuccess = lazy(() => import('../V1/Modules/D5art/LMS/Components/Pages/Payment/StripeSuccess'));
const StripeFailure = lazy(() => import('../V1/Modules/D5art/LMS/Components/Pages/Payment/StripeCancel'));

/*ADMIN*/
const UserDashboard = lazy(() => import("../V1/Modules/D5art/Admin/UserDashboard"));
const AdminLogin = lazy(() => import("../V1/Modules/D5art/Admin/Components/Auth/AdminLogin"));
const AddQuestionSet = lazy(() => import("../V1/Modules/D5art/Admin/AddQuestionSet"));
const AddAssessmentQuestion = lazy(() => import("../V1/Modules/D5art/Admin/AddAssessmentQuestion"));
const AdminAssessmentResult = lazy(() => import("../V1/Modules/D5art/Admin/AssessmentResult"));
const EventRegistration = lazy(() => import("../V1/Modules/D5art/Admin/EventRegistration"));
const ValidationTable = lazy(() => import("../V1/Modules/D5art/RMS/Components/Pages/Seeker/UserDashboard/Pages/Validation/ValidationTable"));
const SeekersList = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Seeker/AllSeekersList"));
const SeekerDetails = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Seeker/FullProfile/FullProfile"));
const DnaUsers = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/DNA/DnaUsers"));
const AdminSettings = lazy(() => import("../V1/Modules/D5art/Admin/Settings/Settings"));
const AddAdmin = lazy(() => import("../V1/Modules/D5art/Admin/Components/Auth/AddAdmin"));
const AdminDnaConsultation = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/DNA/DnaConsultation"));
const ReachUsFormSubmittedEntries = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/ReachUs/FormSubmittedEntries"));
const UploadApk = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/MobileApp/UploadApk"));
const RecruiterList = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Recruiter/RecruiterList"));
const RecruiterDetails = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Recruiter/RecruiterDetails"));
const RecruiterCartDetails = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Recruiter/RecruiterCartDetails"));
const AdminDashboard = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/AdminDashboard"));

const SeekersSnapShot = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/Seeker/SnapShot"));
const AdminCourseList = lazy(() => import("../V1/Modules/AIDM/Dashboard/Pages/AdminCourseList"));
const UploadWebinarUsers = lazy(() => import("../V1/Modules/D5art/Admin/Components/Pages/UploadWebinarUsers"));

// const Loading = () => <div>Loading...</div>;


const AppRoutes = () => {

  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots === '...') {
          return '';
        } else {
          return prevDots + '.';
        }
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const Loading = () => <div className='flex items-center justify-center h-screen bg-black'>
    <div>
      <div className='h-[8rem] w-[12.5rem]'>
        <img src='/assets/Loader/profile_loader.gif' className='w-[75%] mx-auto'></img>
      </div>
      <p className='text-center font-bricolagegrotesque text-sky-300'>Please wait Loading {dots}
      </p>
    </div>
  </div>

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* 🔹 Authentication Routes */}
        <Route path="*" element={<NotFound />} />
        <Route path="/seeker-login" element={<SeekerLogin />} />
        <Route path="/recruiter-login" element={<RecruiterLogin />} />
        <Route path="/validator-login" element={<ValidatorLogin />} />
        {/* <Route path="/sample" element={<Sample />} /> */}
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />


        {/* 🔹 Registration Routes */}
        <Route path='/seeker-register1' element={<Seeker_Register />} />
        <Route path="/seeker-register" element={<SeekerRegister />} />
        <Route path="/recruiter-register" element={<RecruiterRegister />} />
        <Route path="/validator-register" element={<ValidatorRegister />} />
        <Route path="/terms-and-conditions" element={<Terms_Condition />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/refund-policy" element={<Refund_Policy />} />


        {/*Courses*/}
        <Route path="/c/courses" element={<CurrencyProvider> <Courses />  </CurrencyProvider>} />
        <Route path="/pre-course/:course_name/:course_id" element={<CurrencyProvider>  <CoursePreview /></CurrencyProvider>} />
        <Route path="/course-play/:course_name/:course_id" element={<ProtectedRoute allowedRoles={["seeker"]}><CourseVideo /></ProtectedRoute>} />
        <Route path="/nft-certificate/:tokenid" element={<ProtectedRoute allowedRoles={["seeker"]}><NftCertificate /></ProtectedRoute>} />
        {/* <Route path="/pre-assessment"element={<ProtectedRoute allowedRoles={["seeker"]}><PreAssessment /></ProtectedRoute>}  /> */}
        <Route path="/assessment/:assessmentType/:id" element={<ProtectedRoute allowedRoles={["seeker"]}><PreAssessment /></ProtectedRoute>} />
        <Route path="/holland-assessment" element={<ProtectedRoute allowedRoles={["seeker"]}><Assessment /></ProtectedRoute>} />


        {/* 🔹 Seeker Protected Routes */}
        <Route path="/" element={<NewHome />} />
        {/* <Route path="/newlanding" element={<NewHome />} /> */}
        {/* <Route path="/details/:id" element={<Jobdetail />} /> */}
        <Route path="/Ouroffering" element={<Ouroffering />} />
        <Route path="/seeker/validation-result" element={<ValidationResult />} />
        <Route path="/seeker" element={<ProtectedRoute allowedRoles={["seeker"]}><Home /></ProtectedRoute>} />
        <Route path="/seeker/skillarenalist" element={<ProtectedRoute allowedRoles={["seeker"]}><SkillArenalist /></ProtectedRoute>} />
        <Route path="/seeker/skillmarket" element={<ProtectedRoute allowedRoles={["seeker"]}><Skillmarket /></ProtectedRoute>} />
        <Route path="/seeker/profile-update" element={<ProtectedRoute allowedRoles={["seeker"]}><Profileupdate /></ProtectedRoute>} />
        <Route path="/seeker/dashboard" element={<ProtectedRoute allowedRoles={["seeker"]}><SeekerUserDashboard /></ProtectedRoute>} />
        <Route path="/fullprofile" element={<ProtectedRoute allowedRoles={["seeker", "recruiter"]}><FullProfile /></ProtectedRoute>} />
        <Route path="/Congrats" element={<ProtectedRoute allowedRoles={["seeker"]}><Congrats /></ProtectedRoute>} />
        <Route path="/seeker/assessment-result" element={<ProtectedRoute allowedRoles={["seeker"]}><AssessmentResult /></ProtectedRoute>} />
        <Route path="/seeker/upskill" element={<ProtectedRoute allowedRoles={["seeker"]}><UpSkill /></ProtectedRoute>} />
        <Route path="/careergpt" element={<ProtectedRoute allowedRoles={["seeker"]}><CareerGpt /></ProtectedRoute>} />
        <Route path="/career-gpt/chat" element={<ProtectedRoute allowedRoles={["seeker"]}><PromptPage /></ProtectedRoute>} />
        <Route path="/career-gpt/skills" element={<ProtectedRoute allowedRoles={["seeker"]}><SkillsPage /></ProtectedRoute>} />
        <Route path="/career-gpt/career-roadmap" element={<ProtectedRoute allowedRoles={["seeker"]}><CareerRoadmap /></ProtectedRoute>} />


        {/* 

        <Route path="/prompt" element={<PromptPage />} />
        <Route path="/skills" element={<SkillsPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
        <Route path="/CareerRoadmap" element={<CareerRoadmap />} /> */}


        {/* 🔹 Recruiter Protected Routes */}
        <Route path="/recruiter" element={<ProtectedRoute allowedRoles={["recruiter"]}><RecruiterHome /></ProtectedRoute>} />
        <Route path="/recruiter/skillarenalist" element={<ProtectedRoute allowedRoles={["recruiter"]}><RecruiterSkillArenalist /></ProtectedRoute>} />
        <Route path="/recruiter/skillmarket" element={<ProtectedRoute allowedRoles={["recruiter"]}><RecruiterSkillmarket /></ProtectedRoute>} />
        <Route path="/recruiter/dashboard" element={<ProtectedRoute allowedRoles={["recruiter"]}><RecruiterUserDashboard /></ProtectedRoute>} />
        <Route path="/recruiter/recruitgpt" element={<ProtectedRoute allowedRoles={["recruiter"]}><RecruiterGPT /></ProtectedRoute>} />
        <Route path="/recruiter/recruitgpt/skillarenalist" element={<GPTSearchResults />} />


        {/* 🔹 Recruiter post a job Routes */}
        <Route path="/recruiter/job-opening-registration" element={<JobOpeningRegistration />} />
        <Route path="/seeker/job-arena" element={<ProtectedRoute allowedRoles={["seeker", "recruiter"]}><JobArena /></ProtectedRoute>} />
        {/* <Route path="/seeker/job-details/:jobId" element={<JobDetails />} /> */}
        <Route path="/seeker/job-details/:organizationName/:jobRole/:jobId" element={<JobDetails />} />


        {/* 🔹 CXO Protected Routes */}
        <Route path="/CXO/login" element={<CXOLogin />} />
        <Route path="/CXO" element={<ProtectedRoute allowedRoles={["cxo"]}><CXOHome /></ProtectedRoute>} />
        <Route path="/CXO/dashboard" element={<ProtectedRoute allowedRoles={["cxo"]}><CXODashboard /></ProtectedRoute>} />
        <Route path="/CXO/careerhub" element={<ProtectedRoute allowedRoles={["cxo"]}><CXOCareerhub /></ProtectedRoute>} />
        <Route path="/CXO/ticket" element={<ProtectedRoute allowedRoles={["cxo"]}><Ticket /></ProtectedRoute>} />

        {/* 🔹 Common Routes */}
        <Route path="/faq" element={<Faq />} />
        <Route path="/event" element={<HREvent />} />
        <Route path="/event/next-gen" element={<HREvent />} />
        <Route path="/event/start-assessment" element={<ProtectedRoute allowedRoles={["seeker"]}><EventAssessment /></ProtectedRoute>} />
        <Route path="/jordan-event" element={<Jordanhome />} />
        <Route path="/dna-home" element={<Dnahome />} />
        <Route path="/redis-city" element={<RedisCitySelector />} />
        <Route path="/holland/assessment-result" element={<ProtectedRoute allowedRoles={["seeker"]}><JordanResult /></ProtectedRoute>} />
        <Route path="/psychometric-assessment/start" element={<ProtectedRoute allowedRoles={["seeker"]}><PsychometricAssessment /></ProtectedRoute>} />
        <Route path="/psychometric-result/:assessmentId" element={<ProtectedRoute allowedRoles={["seeker"]}><PsychometricResult /></ProtectedRoute>} />
        {/* <Route path="/psychometric-holland-result/" element={<ProtectedRoute allowedRoles={["seeker"]}><AboutMe /></ProtectedRoute>} /> */}


        {/* DNA */}
        <Route path="/dna/consultation" element={<DnaProtectedRoute allowedRoles={["dna_user"]}><DnaConsultations /></DnaProtectedRoute>} />
        <Route path="/dna/result" element={<DnaProtectedRoute allowedRoles={["dna_user"]}><DnaResult /></DnaProtectedRoute>} />
        <Route path="/seeker/AboutMe" element={<ProtectedRoute allowedRoles={["seeker"]}><AboutMe /></ProtectedRoute>} />

        {/* CXO */}
        <Route path="/CXO/login" element={<CXOLogin />} />
        <Route path="/CXO" element={<ProtectedRoute role="cxo"><CXOHome /></ProtectedRoute>} />
        <Route path="/CXO/dashboard" element={<ProtectedRoute role="cxo"><CXODashboard /></ProtectedRoute>} />
        <Route path="/CXO/career-hub" element={<ProtectedRoute role="cxo"><CXOCareerhub /></ProtectedRoute>} />
        <Route path="/CXO/dna-ai-hi" element={<ProtectedRoute role="cxo"><CXODna /></ProtectedRoute>} />
        <Route path="/CXO/ticket" element={<ProtectedRoute role="cxo"><Ticket /></ProtectedRoute>} />
        <Route path="/CXO/Admin/Userdata" element={<ProtectedRoute role="admin"><Userdata /></ProtectedRoute>} />
        <Route path="/CXO/Admin/Group" element={<ProtectedRoute role="admin"><Group /></ProtectedRoute>} />
        <Route path="/CXO/Admin/Consultation" element={<ProtectedRoute role="admin"><Consultation /></ProtectedRoute>} />
        <Route path="/CXO/Admin/Revenue" element={<ProtectedRoute role="admin"><Revenue /></ProtectedRoute>} />


        {/* 🔹 COE Routes */}

        {/* <Route path="/coe/meeting" element={<ProtectedRoute allowedRoles={["seeker"]}><Sample /></ProtectedRoute>} /> */}

        <Route path="/coe/home" element={<CeoHome />} />
        <Route path="/coe/details" element={<CeoDetails />} />
        <Route path="/coe/mydashboard" element={<CeoMyDashboard />} />
        <Route path="/coe/careerhub" element={<CeoCareerHub />} />
        <Route path="/coe/dna_ai" element={<CeoDnaAi />} />
        {/* <Route path="/coe/admin/schedul-meeting" element={<ScheduleMeeting />} />
          <Route path="/coe/admin/create-meeting" element={<CreateMeeting />} />
          <Route path="/coe/admin/add-projects" element={<AddProjects />} />
          <Route path="/coe/admin/edit-projects" element={<EditProject />} /> */}


        {/* PaymentTesting */}
        <Route path="/testpayment" element={<TestPayment />} />
        <Route path="/stripe-success" element={<StripeSuccess />} />
        <Route path="/stripe-cancel" element={<StripeFailure />} />

        {/* AIDM */}

        <Route path="/aidm/dashboard" element={<ProtectedRoute allowedRoles={["seeker"]}><Dashboard /> </ProtectedRoute>} />
        {/* <Route path="/aidm/Description" element={<Description />} /> */}
        <Route path="/course/desc/:courseName/:courseId" element={<Description />} />
        <Route path="/course/modules/:courseId" element={<CourseModules />} />
        <Route path="/aidm/assessment/:day/:courseId" element={<Dashboard />} />
        <Route path="/Courses" element={<AIDMCourses />} />
        <Route path="/aidm/Mycourses" element={<ProtectedRoute><Mycourses /></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute allowedRoles={["seeker"]}><UserDashboard /></ProtectedRoute>} />






        {/* ADMIN */}
        <Route path="/admin/add-question-set" element={<ProtectedRoute allowedRoles={["seeker"]}><AddQuestionSet /></ProtectedRoute>} />
        <Route path="/admin/add-question-bank" element={<ProtectedRoute allowedRoles={["seeker"]}><AddAssessmentQuestion /></ProtectedRoute>} />
        <Route path="/admin/assessment-result" element={<ProtectedRoute allowedRoles={["seeker"]}><AdminAssessmentResult /></ProtectedRoute>} />
        <Route path="/admin/event-registration" element={<ProtectedRoute allowedRoles={["seeker"]}><EventRegistration /></ProtectedRoute>} />
        <Route path="/admin/event-registration" element={<ProtectedRoute allowedRoles={["seeker"]}><EventRegistration /></ProtectedRoute>} />
        <Route path="/admin/validation" element={<ProtectedRoute allowedRoles={["seeker"]}><ValidationTable /></ProtectedRoute>} />
        {/* <Route path="/admin/seekers-list" element={<ProtectedRoute allowedRoles={["seeker"]}><SeekersList /></ProtectedRoute>} /> */}
        {/* <Route path="/admin/seeker-details" element={<ProtectedRoute allowedRoles={["seeker"]}><SeekerDetails /></ProtectedRoute>} /> */}
        <Route path="/admin/dna/users" element={<ProtectedRoute allowedRoles={["seeker"]}><DnaUsers /></ProtectedRoute>} />
        <Route path="/admin/dna/consultations" element={<ProtectedRoute allowedRoles={["seeker"]}><AdminDnaConsultation /></ProtectedRoute>} />
        <Route path="/admin/app/upload-apk" element={<ProtectedRoute allowedRoles={['seeker']}><UploadApk /></ProtectedRoute>} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/add-admin" element={<AddAdmin />} />
        <Route path="/admin/AdminDashboard" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AdminDashboard /></AdminProtectedRoute>} />
        <Route path="/admin/profile" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><Profile /></AdminProtectedRoute>} />
        <Route path="/admin/u/settings" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AdminSettings /></AdminProtectedRoute>} />
        <Route path="/admin/add-question-set" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AddQuestionSet /></AdminProtectedRoute>} />
        <Route path="/admin/add-question-bank" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AddAssessmentQuestion /></AdminProtectedRoute>} />
        <Route path="/admin/assessment-result" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AdminAssessmentResult /></AdminProtectedRoute>} />
        <Route path="/admin/event-registration" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><EventRegistration /></AdminProtectedRoute>} />
        <Route path="/admin/event-registration" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><EventRegistration /></AdminProtectedRoute>} />
        <Route path="/admin/validation" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><ValidationTable /></AdminProtectedRoute>} />
        <Route path="/admin/seekers-list" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><SeekersList /></AdminProtectedRoute>} />
        <Route path="/admin/seeker-details" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><SeekerDetails /></AdminProtectedRoute>} />
        <Route path="/admin/recruiter-list" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><RecruiterList /></AdminProtectedRoute>} />
        <Route path="/admin/recruiter-details" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><RecruiterDetails /></AdminProtectedRoute>} />
        <Route path="/admin/recruiter-cart" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><RecruiterCartDetails /></AdminProtectedRoute>} />
        <Route path="/admin/dna/users" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><DnaUsers /></AdminProtectedRoute>} />
        {/* <Route path="/admin/seeker-details" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><SeekerDetails /></AdminProtectedRoute>} /> */}
        <Route path="/admin/reach-us" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><ReachUsFormSubmittedEntries /></AdminProtectedRoute>} />
        <Route path="/admin/seeker-snapshot" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><SeekersSnapShot /></AdminProtectedRoute>} />
        <Route path="/admin/upload-webinar-users" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><UploadWebinarUsers /></AdminProtectedRoute>} />

          
        {/* <Route path="/admin/course-details" element={<AdminProtectedRoute allowedRoles={['super-admin', 'admin', 'sub-admin']}><AdminCourseList /></AdminProtectedRoute>} /> */}
          

        <Route path="/admin/course-details" element={<AdminCourseList />} />



        {/* Testing */}
        <Route path="/test/KeywordSearch" element={<KeywordSearch />} />
        <Route path="/test/recruitgpt" element={<RecruitGPT />} />

      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
